import Media from "react-media";
import React from "react";
import { connect } from "react-redux";
import "./MenuWrapper.css";
import { templateConstants } from "../../../../../../../constants/cms/template/template.constants";

const MenuWrapper = ({
  children,
  device,
  editMode,
  menuStyle,
  responsiveStyle
}) => {
  if (!menuStyle) return null;
  const setStyle = matches => {
    if (!editMode) {
      if (matches.large) return menuStyle;
      else {
        let dvc = "";
        if (matches.medium) dvc = templateConstants.TABLET;
        else if (matches.small) dvc = templateConstants.SMARTPHONE;
        if (responsiveStyle[dvc] === undefined) return menuStyle
        const style = { ...menuStyle, ...responsiveStyle[dvc].menu };
        style.position = 'unset'
        return style;
      }
    } else {
      if (device === templateConstants.DESKTOP) return menuStyle;
      const style = { ...menuStyle, ...responsiveStyle[device].menu };
      style.position = 'unset'
      return style;
    }
  };
  if(menuStyle.display === 'none') return null;
  return (
    <Media
      queries={{
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }}
    >
      {matches => (
        <div className="cms-menu-wrapper-menu" style={setStyle(matches)}>
          {children}
        </div>
      )}
    </Media>
  );
};
function mapStateToProps(state) {
  return {
    device: state.template.previewDevice,
    editMode: state.cms.editMode,
    menuStyle: state.template.template.content.menu,
    responsiveStyle: state.template.template.content.responsive
  };
}
export default connect(mapStateToProps)(MenuWrapper);
